import ProtectedRoute from "layouts/ProtectedRoute";
import React, { Suspense, lazy } from "react";
import Icon from "@mui/material/Icon";
import DemoDashboard from "layouts/demo";

const Dashboard = lazy(() => import("layouts/dashboard"));
const Assets = lazy(() => import("layouts/netdefenders/Assets"));
const NewScan = lazy(() => import("layouts/netdefenders/NewScan"));
const ScanHistory = lazy(() => import("layouts/netdefenders/ScanHistory"));
const Findings = lazy(() => import("layouts/netdefenders/Findings"));
const Credentials = lazy(() => import("layouts/netdefenders/Credentials"));
const Monitoring = lazy(() => import("layouts/netdefenders/Monitoring"));
const Settings = lazy(() => import("layouts/netdefenders/Settings"));
const Profile = lazy(() => import("layouts/profile"));
const Users = lazy(() => import("layouts/netdefenders/Users"));
const Logs = lazy(() => import("layouts/logs"));
const Billing = lazy(() => import("layouts/netdefenders/Billing"));
const SignIn = lazy(() => import("layouts/authentication/sign-in"));
const SignUp = lazy(() => import("layouts/authentication/sign-up"));
const ResetPassword = lazy(() => import("layouts/authentication/reset-password"));
const lazyElement = (LazyComponent) => (
  <Suspense fallback={null}>
    <LazyComponent />
  </Suspense>
);
const teamRoles = ["admin", "analyst", "client_admin", "client_user", "read_only"];

export default [
  {
    type: "collapse",
    name: "Overview",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Dashboard)}</ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Assets",
    key: "assets",
    icon: <Icon fontSize="small">dns</Icon>,
    route: "/assets",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Assets)}</ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Risks",
    key: "new-scan",
    icon: <Icon fontSize="small">radar</Icon>,
    route: "/risks",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Findings)}</ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Credentials",
    key: "credentials",
    icon: <Icon fontSize="small">vpn_key</Icon>,
    route: "/credentials",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Credentials)}</ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Monitoring",
    key: "monitoring",
    icon: <Icon fontSize="small">radar</Icon>,
    route: "/monitoring",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Monitoring)}</ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/settings",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Settings)}</ProtectedRoute>,
  },
  {
    key: "new-scan",
    route: "/scans/new",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(NewScan)}</ProtectedRoute>,
  },
  {
    key: "scan-history",
    route: "/scans/history",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(ScanHistory)}</ProtectedRoute>,
  },
  {
    key: "findings",
    route: "/findings",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Findings)}</ProtectedRoute>,
  },
  {
    key: "profile",
    route: "/profile",
    component: <ProtectedRoute allowedRoles={teamRoles}>{lazyElement(Profile)}</ProtectedRoute>,
  },
  {
    key: "users",
    route: "/users",
    component: (
      <ProtectedRoute allowedRoles={["admin", "client_admin"]}>{lazyElement(Users)}</ProtectedRoute>
    ),
  },
  {
    key: "logs",
    route: "/logs",
    component: (
      <ProtectedRoute allowedRoles={["admin", "analyst"]}>{lazyElement(Logs)}</ProtectedRoute>
    ),
  },
  {
    key: "billing",
    route: "/billing",
    component: (
      <ProtectedRoute allowedRoles={["admin", "client_admin"]}>
        {lazyElement(Billing)}
      </ProtectedRoute>
    ),
  },
  { key: "demo", route: "/demo", component: <DemoDashboard /> },
  { key: "sign-in", route: "/authentication/sign-in", component: lazyElement(SignIn) },
  { key: "sign-in-short", route: "/sign-in", component: lazyElement(SignIn) },
  { key: "sign-up", route: "/authentication/sign-up", component: lazyElement(SignUp) },
  { key: "sign-up-short", route: "/sign-up", component: lazyElement(SignUp) },
  {
    key: "reset-password",
    route: "/authentication/reset-password",
    component: lazyElement(ResetPassword),
  },
];
